import React, { FC, useState } from 'react';
import { Paper } from '@mui/material';
import { useSelector } from 'react-redux';

import CurrentTimeRepository from 'src/api/repositories/common/v1/currentTime.repository';
import APP_VERSION from 'src/app.version';
import { useAsyncEffect } from 'src/shared/hooks';
import { useTranslate } from 'src/shared/providers';
import { getEssApiVersion } from 'src/store/user/user.selectors';

export const VersionSection: FC = () => {
  const { t } = useTranslate();
  const apiVersion = useSelector(getEssApiVersion);
  const [commonApiVersion, setCommonApiVersion] = useState<string>();

  useAsyncEffect(
    async () => {
      const repository = new CurrentTimeRepository();
      const { apiVersion } = await repository.get();
      setCommonApiVersion(apiVersion);
    },
    undefined,
    undefined,
    [],
  );

  return (
    <Paper className="h-100 p-4">
      <div className="mb-4">
        <h4 className="pb-0 mb-0">{t('settings.version')}</h4>
      </div>
      <div className="my-2 d-flex align-items-center flex-wrap">
        <div>
          <p className="mb-0 fw-500">{t('settings.application')}</p>
          <label className="text-muted d-block">{APP_VERSION}</label>
        </div>
      </div>
      <div className="my-2 d-flex align-items-center flex-wrap">
        <div>
          <p className="mb-0 fw-500">ESS</p>
          <label className="text-muted d-block">{apiVersion}</label>
        </div>
      </div>
      <div className="my-2 d-flex align-items-center flex-wrap">
        <div>
          <p className="mb-0 fw-500">Common</p>
          <label className="text-muted d-block">{commonApiVersion}</label>
        </div>
      </div>
    </Paper>
  );
};
